import { useState } from "react";
import { FileText } from "lucide-react";
import { fileUrl } from "@/lib/api";

// Image preview for evidence files; non-image files (PDF/TXT/DOCX) fall back to a document icon.
export const EvidenceThumb = ({ fileId, alt, className, iconClassName = "w-4 h-4" }) => {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <span data-testid="evidence-thumb-doc" className={`${className} bg-black/50 flex items-center justify-center`}>
        <FileText className={`${iconClassName} text-neutral-600`} />
      </span>
    );
  }
  return <img data-testid="evidence-thumb-img" src={fileUrl(fileId)} alt={alt} className={className} onError={() => setFailed(true)} />;
};
